import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  InputLabel,
  Paper,
} from '@material-ui/core';
import { 
  renderCheckbox,
  renderSelectField6,
} from '../../../form-global-components/components-form-components-for-react-final-form';
import {
  NA_YES_NO,
  NO_YES,
  UNKNOWN_YES_NO,
} from '../../../../actions/action-constants';
class FormFieldsTabClientDetailsTabsReferralConditions extends Component {
  render() {
    return (
      <div>
        <Paper >
          <Card>
            <CardContent>
            
              <Grid container spacing={3}>  
                <Grid item xs={12}>
                  <InputLabel>
                    Homeless in past 12 months or 12 months preceding incarceration
                  </InputLabel>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='referralhomelesshistory'
                      name='referralhomelesshistory'
                      objName='referralhomelesshistory'
                      label='History'
                      footerMessage=''
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='referralhomelesscurrent'
                      name='referralhomelesscurrent'
                      objName='referralhomelesscurrent'
                      label='Current'
                      footerMessage=''
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='referralhomelessna'
                      name='referralhomelessna'
                      objName='referralhomelessna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputLabel>
                    Behavioral / Mental Health Issues
                  </InputLabel>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='referralmentalhealthissueshistory'
                    name='referralmentalhealthissueshistory'
                    objName='referralmentalhealthissueshistory'
                    label='History'
                    footerMessage=''
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='referralmentalhealthissuescurrent'
                    name='referralmentalhealthissuescurrent'
                    objName='referralmentalhealthissuescurrent'
                    label='Current'
                    footerMessage=''
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='referralmentalhealthissuesna'
                      name='referralmentalhealthissuesna'
                      objName='referralmentalhealthissuesna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputLabel>
                    Substance Use Disorder
                  </InputLabel>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='referralsubstanceusedisorderissueshistory'
                    name='referralsubstanceusedisorderissueshistory'
                    objName='referralsubstanceusedisorderissueshistory'
                    label='History'
                    footerMessage=''
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='referralsubstanceusedisorderissuescurrent'
                    name='referralsubstanceusedisorderissuescurrent'
                    objName='referralsubstanceusedisorderissuescurrent'
                    label='Current'
                    footerMessage=''
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='referralsubstanceusedisorderissuesna'
                      name='referralsubstanceusedisorderissuesna'
                      objName='referralsubstanceusedisorderissuesna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputLabel>
                    Co-occurring Disorders
                  </InputLabel>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='referralcooccurringhistory'
                    name='referralcooccurringhistory'
                    objName='referralcooccurringhistory'
                    label='History'
                    footerMessage=''
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='referralcooccurringcurrent' 
                    name='referralcooccurringcurrent'
                    objName='referralcooccurringcurrent'
                    label='Current'
                    footerMessage=''
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='referralcooccurringna'
                      name='referralcooccurringna'
                      objName='referralcooccurringna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12}>
                  <InputLabel>
                    Employed in past 12 months or 12 months preceding incarceration
                  </InputLabel>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Field
                      locked={this.props.locked}
                      component={renderCheckbox}
                      id='referralemployedduringpasthistory'
                      name='referralemployedduringpasthistory'
                      objName='referralemployedduringpasthistory'
                      label='History'
                      footerMessage=''
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                <Field
                      locked={this.props.locked}
                      component={renderCheckbox}
                      id='referralemployedduringpastcurrent'
                      name='referralemployedduringpastcurrent'
                      objName='referralemployedduringpastcurrent'
                      label='Current'
                      footerMessage=''
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Field
                      component={renderCheckbox}
                      locked={this.props.locked}
                      id='referralemployedduringpastna'
                      name='referralemployedduringpastna'
                      objName='referralemployedduringpastna'
                      label='N / A'
                      footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    required
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='referralriskofvictimization' 
                    name='referralriskofvictimization'
                    label='Referral Risk of Victimization'
                    footerMessage=''
                                          // dataArray={UNKNOWN_YES_NO}
                    dataArray={NA_YES_NO}
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='0' >Unknown</option>
                                                                                    <option value='1' >Yes</option>
                                                                                    <option value='2' >No</option>
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    required
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='referralriskasperpetrator' 
                    name='referralriskasperpetrator'
                    label='Referral Risk As Perpetrator'
                    footerMessage=''
                    dataArray={UNKNOWN_YES_NO}
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='0' >Unknown</option>
                                                                                    <option value='1' >Yes</option>
                                                                                    <option value='2' >No</option>
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='referralprescribedmedications' 
                    name='referralprescribedmedications'
                    label="Prescribed Medications"
                    footerMessage=''
                    dataArray={NO_YES}
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='0' >No</option>
                                                                                    <option value='1' >Yes</option>
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>

              <Grid container spacing={3}>  
                <Grid item xs={12} >
                  <Field
                    autoFocus
                    locked={this.props.locked}
                    component={renderSelectField6}
                    id='referralmedicationsupplyprovided' 
                    name='referralmedicationsupplyprovided'
                    label="Medication Supply Provided With Client"
                    footerMessage=''
                    dataArray={NO_YES}
                  />
                                                                {/* 
                                                                                  >
                                                                                    <option value='0' >No</option>
                                                                                    <option value='1' >Yes</option>
                                                                                  </Field> 
                                                                */}
                </Grid>
              </Grid>


            </CardContent>
          </Card>
        </Paper>  
        
      </div>
    );
  }
}
FormFieldsTabClientDetailsTabsReferralConditions.propTypes = {
  locked: PropTypes.bool,
}
export default FormFieldsTabClientDetailsTabsReferralConditions;